// extracted by mini-css-extract-plugin
module.exports = {"root":"_2v-B0","icon":"_3KXu1","text":"_1df_W"};